import userSelectors from '../selectors';
import userActions from '../actions';
import { useAppDispatch } from 'store/hooks';

const useGetListStaffAttendance = () => {
  const dispatch = useAppDispatch();
  const listStaffAttendance = userSelectors.getListStaffAttendance();

  const mutate = () => {
    dispatch(userActions.getListStaffAttendance.fetch());
  };

  return {
    listStaffAttendance,
    mutate,
  };
};

export default useGetListStaffAttendance;
